import { Column, Heading, Text } from '@stenajs-webui/core';
import { PrimaryButton } from '@stenajs-webui/elements';
import React, { FC, useState } from 'react';
import Form from './Form';
import Input from './Input';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { transformValues } from '../utils/utils';
import { validateEmail } from '../utils/emailValidation';

export interface PartyDetails {
  firstName: string;
  lastName: string;
  email: string;
}

interface Props {
  loading: boolean;
  handleSubmit: (response: PartyDetails) => void;
}

const PartyDetailsForm: FC<Props> = (props) => {
  const { loading, handleSubmit } = props;

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [emailTouched, setEmailTouched] = useState(false);
  const emailError = emailTouched && !validateEmail(email.trim());

  return (
    <Form
      onSubmit={(model: PartyDetails) => {
        const normalized = transformValues(model, (value) => value.trim());
        setEmail(normalized.email);
        setEmailTouched(true);
        if (!normalized.firstName || !normalized.lastName || !validateEmail(normalized.email)) {
          return;
        }
        handleSubmit(normalized);
      }}
    >
      <Column gap={6}>
        <Heading variant="h2">Confirm details</Heading>
        <Input
          required
          name="firstName"
          label="First name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          onBlur={(e) => setFirstName(e.target.value.trim())}
        />
        <Input
          required
          name="lastName"
          label="Last name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          onBlur={(e) => setLastName(e.target.value.trim())}
        />
        <Column gap={1} style={{ textAlign: 'left' }}>
          <Input
            required
            name="email"
            label="Email"
            inputMode="email"
            autoComplete="email"
            value={email}
            variant={emailError ? 'error' : 'standard'}
            aria-invalid={emailError}
            aria-describedby={emailError ? 'email-error' : undefined}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={(e) => {
              setEmail(e.target.value.trim());
              setEmailTouched(true);
            }}
          />
          {emailError && (
            <Text id="email-error" role="alert" size="small" color="var(--swui-state-error-color)">
              Please enter a valid email address.
            </Text>
          )}
        </Column>
        <PrimaryButton loading={loading} loadingLabel="Confirming..." leftIcon={faArrowUpRightFromSquare} type="submit" label="Go to claim" />
      </Column>
    </Form>
  );
};

export default PartyDetailsForm;
